import { apiRequest } from "./api";
import type {
  CreateStripeIdentityVerificationSessionResponse,
  CreateGigFundingSessionRequest,
  CreateGigFundingSessionResponse,
  SelectPayoutGuardianRequest,
  StripeIdentityVerificationResponse,
  StripeOnboardingLinkResponse,
  StripePayoutProfileResponse,
  UpdatePayoutOwnerRequest,
} from "../types/stripeTypes";

export const stripeApi = {
  getTeenPayoutProfile(): Promise<StripePayoutProfileResponse> {
    return apiRequest<StripePayoutProfileResponse>("/api/account/stripe/payout-profile", {
      method: "GET",
    });
  },

  createTeenPayoutOnboardingLink(): Promise<StripeOnboardingLinkResponse> {
    return apiRequest<StripeOnboardingLinkResponse>("/api/account/stripe/payout-profile/onboarding-link", {
      method: "POST",
    });
  },

  sendTeenPayoutGuardianNotification(): Promise<StripePayoutProfileResponse> {
    return apiRequest<StripePayoutProfileResponse>("/api/account/stripe/payout-profile/guardian-notification", {
      method: "POST",
    });
  },

  selectTeenPayoutGuardian(payload: SelectPayoutGuardianRequest): Promise<StripePayoutProfileResponse> {
    return apiRequest<StripePayoutProfileResponse>("/api/account/stripe/payout-profile/guardian-selection", {
      method: "PATCH",
      body: payload,
    });
  },

  updateTeenPayoutOwner(payload: UpdatePayoutOwnerRequest): Promise<StripePayoutProfileResponse> {
    return apiRequest<StripePayoutProfileResponse>("/api/account/stripe/payout-profile/owner", {
      method: "PATCH",
      body: payload,
    });
  },

  getAdultIdentityVerification(): Promise<StripeIdentityVerificationResponse> {
    return apiRequest<StripeIdentityVerificationResponse>("/api/account/stripe/identity-verification", {
      method: "GET",
    });
  },

  createAdultIdentityVerificationSession(): Promise<CreateStripeIdentityVerificationSessionResponse> {
    return apiRequest<CreateStripeIdentityVerificationSessionResponse>("/api/account/stripe/identity-verification/session", {
      method: "POST",
    });
  },

  createGigFundingCheckoutSession(
    requestId: string,
    payload: CreateGigFundingSessionRequest,
  ): Promise<CreateGigFundingSessionResponse> {
    return apiRequest<CreateGigFundingSessionResponse>(`/api/adult/gig-requests/${requestId}/funding-checkout-session`, {
      method: "POST",
      body: payload,
    });
  },
};
